import { Controller } from "@hotwired/stimulus";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export default class extends Controller {
    static targets = ["swiper", "prev", "next"]

    initialize() {
        const swiper = new Swiper(this.swiperTarget, {
            modules: [Navigation],
            slidesPerView: 1,
            navigation: {
                nextEl: this.nextTargets,
                prevEl: this.prevTargets,
            },
            loop: true,
            autoHeight: true,
        });

        this.prevTargets.forEach(element => {
           element.classList.add("swiper-button-disabled"); 
        });

        swiper.on('slideChangeTransitionStart', () => {
            this.prevTargets.forEach(element => {
                element.classList.remove("pointer-events-none");
            });
        });

        this.nextTargets.forEach(el => {
            el.addEventListener("keydown", this.handleKeydown);
        });

        this.prevTargets.forEach(el => {
            el.addEventListener("keydown", this.handleKeydown);
        });
    }

    handleKeydown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            event.currentTarget.click();
        }
    }
}